import { PureComponent } from 'react'
import { Field } from 'redux-form'
import TextFieldWrapped from 'components/atoms/inputs/TextFieldWrapped'
import { FIELD_REDEMPTION_AMOUNT_PROPS, FIELD_CURRENCY_WRAPPED_PROPS } from 'constants/fields'
import * as styles from 'components/features/pfm/RedemptionForm/AmountStep.css'
import SubmitButton from 'components/features/pfm/RedemptionForm/SubmitButton'
import CancelButton from 'components/features/pfm/RedemptionForm/CancelButton'
import { ReduxFormProps } from 'interfaces/component'
import redemptionReduxForm from 'components/features/pfm/RedemptionForm/redemptionReduxForm'
import { amountStepSchema } from 'schemas/redemptionSchema'
import { RedemptionFormValues } from 'interfaces/bounty'
import resolveErrorById, { MIN_REDEMPTION_AMOUNT, MAX_REDEMPTION_AMOUNT } from 'constants/errors'

type AmountStepProps = ReduxFormProps<RedemptionFormValues> & {
  rewardBalance: number
  minRedemptionAmount: number
}

class AmountStep extends PureComponent<AmountStepProps> {
  render () {
    const { rewardBalance, handleSubmit } = this.props

    return (
      <form onSubmit={ handleSubmit } className={ styles.amountStep }>
        <div className={ styles.rewardBalance }>
          Available Balance: ${ rewardBalance }
        </div>
        <div className={ styles.redemptionAmountWrapper }>
          <Field
            name='amount'
            component={ TextFieldWrapped }
            props={ FIELD_REDEMPTION_AMOUNT_PROPS }
            normalize={ FIELD_CURRENCY_WRAPPED_PROPS.normalize }
            validate={ this.validateRedemptionAmount }
          />
        </div>
        <div className={ styles.buttonWrapper }>
          <SubmitButton>Proceed to Account Info</SubmitButton>
        </div>
        <CancelButton />
      </form>
    )
  }

  private validateRedemptionAmount = (value: number | null | undefined) => {
    const { rewardBalance, minRedemptionAmount } = this.props
    if (!value || value < minRedemptionAmount) {
      return resolveErrorById(MIN_REDEMPTION_AMOUNT, minRedemptionAmount)
    }

    if (rewardBalance !== null && value && value > rewardBalance) {
      return resolveErrorById(MAX_REDEMPTION_AMOUNT)
    }

    return null
  }
}

export default redemptionReduxForm(AmountStep,  amountStepSchema)
